import React from 'react';
import { TextField } from '@material-ui/core';
import { Controller } from 'react-hook-form';
import RadioOption from '../../components/FormOptions/RadioOption';
import { useLang } from '../../util/lang';
import styles from '../RestorativePhaseCaseIntake.module.css';

/** Renders mock-up feedback in editable or read-only mode. */
const MockupFeedbackStep = ({ control, get, mockupFeedback, readOnly = false, data = {} }) => {
    const languageGet = useLang();
    const translate = get || languageGet;
    const feedback = readOnly ? data.mockupFeedback : mockupFeedback;
    const remark = readOnly ? data.mockupFeedbackRemark : undefined;
    const feedbackLabel = {
        approved: translate('@PatientInfo.smileDesign.restorativePhase.options.mockupApproved'),
        adjustmentRequired: translate('@PatientInfo.smileDesign.restorativePhase.options.mockupAdjustmentRequired'),
    }[feedback] || feedback;

    if (readOnly) {
        return (
            <div className={styles.content}>
                <div className="restorative-question-title">1. {translate('@PatientInfo.smileDesign.restorativePhase.mockupQuestion')}</div>
                <div className="restorative-readonly-value">{feedbackLabel || '-'}</div>
                <div className="restorative-question-title">2. {translate('@PatientInfo.smileDesign.restorativePhase.remark')}</div>
                <div className="restorative-readonly-value">{remark || '-'}</div>
            </div>
        );
    }

    return (
        <div className={styles.content}>
            <div className={styles.heading}>{translate('@PatientInfo.smileDesign.restorativePhase.mockupTitle')}</div>
            <div className={styles.subheading}>{translate('@PatientInfo.smileDesign.restorativePhase.stepThree')}</div>
            <div className={styles.description}>{translate('@PatientInfo.smileDesign.restorativePhase.mockupDescription')}</div>
            <div className="restorative-question-title">
                1. {translate('@PatientInfo.smileDesign.restorativePhase.mockupQuestion')} <b>*</b>
            </div>
            <Controller
                name="mockupFeedback"
                control={control}
                rules={{ required: 'Required' }}
                render={({ field }) => (
                    <div className="restorative-card-grid">
                        {[
                            {
                                value: 'approved',
                                label: translate('@PatientInfo.smileDesign.restorativePhase.options.mockupApproved'),
                                description: translate('@PatientInfo.smileDesign.restorativePhase.options.mockupApprovedDescription'),
                            },
                            {
                                value: 'adjustmentRequired',
                                label: translate('@PatientInfo.smileDesign.restorativePhase.options.mockupAdjustmentRequired'),
                                description: translate('@PatientInfo.smileDesign.restorativePhase.options.mockupAdjustmentRequiredDescription'),
                            },
                        ].map((option) => (
                            <RadioOption
                                key={option.value}
                                {...option}
                                className="restorative-option-card"
                                selected={field.value === option.value}
                                onChange={() => field.onChange(option.value)}
                            />
                        ))}
                    </div>
                )}
            />
            <div className="restorative-question-title">
                2. {translate('@PatientInfo.smileDesign.restorativePhase.remark')}{' '}
                {mockupFeedback === 'adjustmentRequired' && <b>*</b>}
            </div>
            <Controller
                name="mockupFeedbackRemark"
                control={control}
                defaultValue=""
                rules={mockupFeedback === 'adjustmentRequired' ? { required: 'Required' } : undefined}
                render={({ field }) => (
                    <TextField
                        {...field}
                        multiline
                        rows={4}
                        variant="outlined"
                        fullWidth
                        placeholder={translate(mockupFeedback === 'adjustmentRequired' ? '@PatientInfo.smileDesign.restorativePhase.adjustmentsDescribe' : '@PatientInfo.smileDesign.restorativePhase.optional')}
                    />
                )}
            />
            {mockupFeedback === 'adjustmentRequired' && (
                <>
                    <div className={styles.noticeRed}>{translate('@PatientInfo.smileDesign.restorativePhase.adjustmentScanNotice')}</div>
                    <div className={styles.notice}>{translate('@PatientInfo.smileDesign.restorativePhase.adjustmentScanNoticeRemark')}</div>
                </>
            )}
        </div>
    );
};

export default MockupFeedbackStep;
